import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT } from "@/lib/api";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-[#0A2540] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <p className="font-display font-extrabold tracking-tight text-2xl">
            SKYWORTH<span className="text-sky-400">CARS</span>
            <span className="text-sm text-slate-300">.ch</span>
          </p>
          <p className="mt-4 text-sm text-slate-300 leading-relaxed max-w-xs">
            {t("footer.tagline")}
          </p>
        </div>
        <div>
          <p className="text-sm tracking-[0.2em] uppercase font-semibold text-slate-400">{t("footer.navTitle")}</p>
          <ul className="mt-4 space-y-3 text-sm">
            <li><Link to="/modelle" className="text-slate-200 hover:text-white">{t("nav.models")}</Link></li>
            <li><Link to="/galerie" className="text-slate-200 hover:text-white">{t("nav.gallery")}</Link></li>
            <li><Link to="/probefahrt" className="text-slate-200 hover:text-white">{t("cta.testDrive")}</Link></li>
            <li><Link to="/flotten" className="text-slate-200 hover:text-white">{t("nav.fleet")}</Link></li>
            <li><Link to="/kontakt" className="text-slate-200 hover:text-white">{t("nav.contact")}</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-sm tracking-[0.2em] uppercase font-semibold text-slate-400">{t("footer.contactTitle")}</p>
          <ul className="mt-4 space-y-3 text-sm text-slate-200">
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-sky-400" />
              <a href={CONTACT.phoneHref} data-testid="footer-phone" className="hover:text-white">{CONTACT.phone}</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-sky-400" />
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="hover:text-white">{CONTACT.email}</a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 text-sky-400 mt-0.5" />
              <span data-testid="footer-address">{CONTACT.address}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between gap-2 text-xs text-slate-400">
          <span>© {new Date().getFullYear()} {t("footer.rights")}</span>
          <a href="https://www.youtube.com/@Skyworth-Auto" target="_blank" rel="noreferrer"
             data-testid="footer-youtube-link" className="hover:text-white">
            {t("footer.youtube")}
          </a>
          <span>{t("footer.legal")}</span>
        </div>
      </div>
    </footer>
  );
}
